import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Button,
  Grid,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import './panoramaViewer.scss';
import { SKUs, skuTypes } from './types';
import { PanoramaMenuItem } from './PanoramaMenuItem';

import { HomeObjectProduct } from '../../models/homes.models';
interface PanoramaMenuProps {
  menuOpen: boolean;
  setMenuOpen: React.Dispatch<React.SetStateAction<boolean>>;
  skus: SKUs | null;
  setSkuId: (groupId: string, skuId: string) => void;
  homeModelProducts: HomeObjectProduct[];
  styleId: string;
  homeId: string;
  locationId: string;
}

export const PanoramaMenu = (props: PanoramaMenuProps) => {
  const {
    skus,
    menuOpen,
    setMenuOpen,
    setSkuId,
    homeModelProducts,
    styleId,
    homeId,
    locationId,
  } = props;
  const names = {
    '@locations': 'Locations',
    '@styles': 'Styles',
  };

  return (
    <div
      style={{
        backgroundColor: 'white',
        maxWidth: menuOpen ? '100%' : '0%',
        width: '500px',
        opacity: menuOpen ? 1 : 0,
        position: 'absolute',
        height: '100%',
        left: menuOpen ? '0' : '-500px',
        top: 0,
        zIndex: 1,
        transition: 'left 0.5s ease-in-out, opacity 0.5s ease-in-out',
        paddingBottom: 8,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <div
        style={{
          textAlign: 'right',
          paddingBottom: '8px',
          borderBottom: '1px solid #e0e0e0',
        }}
      >
        <Button variant="text" onClick={() => setMenuOpen(false)}>
          {'Close'}
        </Button>
      </div>
      <div
        style={{
          height: 1,
          flexGrow: 1,
          overflow: 'auto',
        }}
      >
        {Object.keys(skus || {}).map((sku, i) => {
          return (
            <Accordion
              key={`accordion-${sku}`}
              defaultExpanded
              style={{ margin: 0, paddingLeft: '8px', boxShadow: 'none' }}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls={`panel${i}-content`}
                id={`panel${i}-header`}
              >
                {names[sku as keyof typeof names]
                  ? names[sku as keyof typeof names]
                  : sku.charAt(0).toUpperCase() +
                    sku.replace('_', ' ').slice(1)}
              </AccordionSummary>
              <AccordionDetails>
                <Grid container direction={'column'} spacing={1}>
                  {(skus?.[sku as skuTypes] || []).map((skuForItem: string) => {
                    return (
                      <PanoramaMenuItem
                        key={`menu-item-${sku}-${skuForItem}`}
                        homeModelProducts={homeModelProducts}
                        sku={skuForItem}
                        currentSkuGroupId={sku as skuTypes}
                        setSkuId={setSkuId}
                        styleId={styleId}
                        locationId={locationId}
                        homeId={homeId}
                      />
                    );
                  })}
                </Grid>
              </AccordionDetails>
            </Accordion>
          );
        })}
      </div>
    </div>
  );
};
